<template>
  <div class="deviceRenewal">
    <ManageBox class="renewal">
      <template slot="upside">
        <div class="renewal__header">
          <span class="title">
            登陆账户:
            <span>{{user && user.userName}}</span>
          </span>
          <span class="title">
            加设备币:
            <span>{{user && user.money}}</span>
          </span>
          <a
            @click.stop="dowloadExcl"
          >
            续费操作说明书
          </a>

        </div>
      </template>
      <div
        class="renewal__content"
        slot="content"
      >
        <el-tabs v-model="activeName">
          <el-tab-pane
            label="设备续费"
            name="first"
          >
            <renewal
              @update="queryMyState"
              :activeName.sync="activeName"
            />
          </el-tab-pane>
          <el-tab-pane
            label="续费记录"
            name="second"
          >
            <renewalRecord :activeName.sync="activeName" />
          </el-tab-pane>
          <el-tab-pane
            label="设备币划拨"
            name="third"
          >
            <coinDevice
              @update="queryMyState"
              :activeName.sync="activeName"
            />
          </el-tab-pane>
          <el-tab-pane
            label="设备币划拨记录"
            name="fourth"
          >
            <deviceRecord :activeName.sync="activeName" />
          </el-tab-pane>
          <!--           v-if="USER&&USER.userId === 1" -->
          <el-tab-pane
            v-if="USER&&USER.userId === 58"
            label="充值"
            name="fifth"
          >
            <recharge
              @update="queryMyState"
              :activeName.sync="activeName"
            />
          </el-tab-pane>
          <el-tab-pane
            v-if="USER&&USER.userId === 58"
            label="充值统计"
            name="sixth"
          >
            <rechargeStatistic :activeName.sync="activeName" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </ManageBox>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ManageBox from "@/components/ManageBox/index.vue";
import renewal from "./table/renewal.vue";
import renewalRecord from "./table/renewalRecord.vue";
import coinDevice from "./table/coinDevice.vue";
import deviceRecord from "./table/deviceRecord.vue";
import recharge from "./table/recharge.vue";
import rechargeStatistic from "./table/rechargeStatistic.vue";

export default {
  components: {
    ManageBox,
    renewal,
    renewalRecord,
    coinDevice,
    deviceRecord,
    recharge,
    rechargeStatistic
  },

  data () {
    return {
      activeName: "first",
      user: this.USER
    }
  },
  mounted() {
    this.queryMyState();
    this.open();
  },
  computed: {
    ...mapState(["USER"])
  },
  watch: {
    $route: {
      handler(to) {
        to.name === "deviceRenewal" && this.open();
      },
      immediate: true
    },
    activeName: {
      handler(val) {
        val === "fifth" && this.tip();
      }
    }
  },
  methods: {
    dowloadExcl() {
      this.$API.doDownVehFile({
        sessionId: this.USER.sessionId
      });
    },
    async queryMyState() {
      try {
        const { data } = await this.$API.queryMyState();
        this.user = data;
      } catch (error) {
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      }
    },
    open() {
      const h = this.$createElement;
      this.$msgBox({
        title: "",
        customClass: "mymsgBox",
        message: h(
          "div",
          {
            style:
              "display:flex;justify-content: space-around;align-items: center;padding:20px"
          },
          [
            h(
              "span",
              {
                style: "margin-right:40px"
              },
              [
                h("img", {
                  attrs: { src: require("@/assets/img/managedata/warning.png") }
                })
              ]
            ),
            h("ul", null, [
              h("li", { style: "padding:5px 0" }, [
                h("span", {
                  style:
                    "display:inline-block;width:6px;height:6px;border-radius:50%;background:#18C18B;margin-right:5px"
                }),
                h("span", null, "加设备币划拨后将不可撤回，请谨慎操作！")
              ]),
              h("li", { style: "padding:5px 0" }, [
                h("span", {
                  style:
                    "display:inline-block;width:6px;height:6px;border-radius:50%;background:#18C18B;margin-right:5px"
                }),
                h("span", null, "设备续费后将不可撤回，请谨慎操作！  ")
              ]),
              h("li", { style: "padding:5px 0" }, [
                h("span", {
                  style:
                    "display:inline-block;width:6px;height:6px;border-radius:50%;background:#18C18B;margin-right:5px"
                }),
                h("span", null, "服务到期前删除设备，加设备币将不予退回！  ")
              ]),
              h("li", { style: "padding:5px 0" }, [
                h("span", {
                  style:
                    "display:inline-block;width:6px;height:6px;border-radius:50%;background:#18C18B;margin-right:5px"
                }),
                h("span", null, "1个币=1月， 一次性续费1年优惠后只需5个币！")
              ])
            ])
          ]
        ),
        confirmButtonText: "确定"
      }).then(action => {
        return;
      }).catch(err => {
        return
      });
    },
    tip() {
      const h = this.$createElement;
      this.$msgBox({
        title: "",
        message: h(
          "div",
          { style: "display:flex;flex-direction: column;align-items: center;" },
          [
            h("span", { style: "margin-bottom:10px" }, [
              h("img", {
                attrs: { src: require("@/assets/img/managedata/charge.png") }
              })
            ]),
            h("ul", null, [
              h("li", { style: "padding:5px 0" }, [
                h("span", null, "充值后将不可撤回，请谨慎操作！")
              ])
            ])
          ]
        ),
        confirmButtonText: "确定",
        center: true
      }).then(action => {
        return;
      }).catch(err => {
        return
      });;
    }
  }
}
</script>
<style scoped lang="scss">
.renewal {
  display: flex;
  align-items: center;
  &__header {
    width: 100%;
    position: relative;
    margin-left: -15px;
    & > span {
      white-space: nowrap;
      margin: 0 15px;
      font-weight: bold;
      color: #666;
      & > span {
        font-weight: normal;
        color: rgb(126, 126, 126);
      }
    }
    a {
      position: absolute;
      right: 0;
      cursor: pointer;
      text-decoration: underline;
      &:hover {
        color: rgba(15, 121, 121, 0.986);
      }
    }
  }
  &__content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 16px;
  }
}
::v-deep .el-tabs__item:focus {
  box-shadow: none !important;
}
::v-deep .mymsgBox {
  width: 600px !important;
  padding: 20px;
}
</style>
<style lang="scss">
// .el-message-box__header {
//   background: rgb(184, 12, 12) !important;
//   .el-message-box__title {
//     color: rgb(107, 224, 228);
//     font-weight: bold;
//   }
//   .el-message-box__headerbtn .el-message-box__close {
//     color: #fff;
//   }
// }
.el-message-box {
  border: none;
  border-radius: 0;
  width: auto;
  
}
.deviceRenewal .ManageBox__upside {
  margin: 10px 0;
  height: 50px;
}
</style>